import axios from "axios";

 const baseUrl: string = "https://api.easyturf.in/api/";
// const baseUrl: string = "http://127.0.0.1:3100/api/";



const getAuthHeaders = () => {
    const profile= JSON.parse(localStorage.getItem("profile") || "{}");
    const token=profile.token;
    // const token = AppStore.getState().token; 
     console.log("Token is", token);
  
    if (!token) {
      console.error("Token is missing");
      return {}; 
    }
  
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "type":"user"
    };
  };
  
export const addContactUsDetail = (data: any) => {
    return axios.post(baseUrl + 'website_contact/add_contact_us', data);
}



// login api with otp
export const get_userLoginData = (data: any) => {
    console.log("api", data);
    return axios.post(baseUrl + "user/send_otp", data);
  };
  
  //  delete user api
export const delete_user = (data: any) => {
    //console.log(data,'slot api');
    // pass token in header
    const headers = getAuthHeaders();
    return axios.post(baseUrl + "user/delete_user", data, { headers });
  };